/* Généré par construire.mjs depuis theme-src/animolife.js : ne pas modifier ici. */
/* Comportements de la boutique Animolife, repris du front React d'origine : thème, feuilles,
   panier, favoris, sélection, fiche produit, zoom, visionneuse et lecteur. */
(() => {
  "use strict";

  const H = window.animolife || { routes: {}, textes: {}, livraison: {} };
  const T = H.textes;
  // Le serveur des agents, derrière le proxy de Shopify : codes personnels, espace client, radar
  const agents = (H.agents || "/apps/hanabi").replace(/\/$/, "");
  // Le filtre t de Shopify échappe les apostrophes (&#39;) : les textes lus par le script sont décodés une fois
  const decodeur = document.createElement("textarea");
  const decoder = (v) => {
    if (typeof v === "string") {
      decodeur.innerHTML = v;
      return decodeur.value;
    }
    if (v && typeof v === "object") for (const k of Object.keys(v)) v[k] = decoder(v[k]);
    return v;
  };
  decoder(T);
  const $ = (sel, racine = document) => racine.querySelector(sel);
  const $$ = (sel, racine = document) => [...racine.querySelectorAll(sel)];
  const icone = (nom, taille = 18) =>
    `<svg class="icone" width="${taille}" height="${taille}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${(window.animolifeIcones || {})[nom] || ""}</svg>`;
  const remplir = (modele, vars) => modele.replace(/__(\w+)__/g, (_, k) => (k in vars ? vars[k] : `__${k}__`));
  // Les gestes propres à la boutique, publiés pour les pixels de mesure ; sans effet si Shopify ne les écoute pas
  const publier = (nom, donnees = {}) => {
    try {
      window.Shopify?.analytics?.publish?.(`animolife:${nom}`, donnees);
    } catch {
      /* la mesure ne casse jamais la boutique */
    }
  };

  const stockage = {
    lire(cle, defaut) {
      try {
        const v = localStorage.getItem("animolife:" + cle);
        return v === null ? defaut : JSON.parse(v);
      } catch {
        return defaut;
      }
    },
    ecrire(cle, valeur) {
      try {
        localStorage.setItem("animolife:" + cle, JSON.stringify(valeur));
      } catch {
        /* navigation privée : le choix vaut pour la page */
      }
    },
  };
  // Le temps d'une visite : ce que le serveur a dit du client connecté
  const memoire = {
    lire(cle) {
      try {
        return JSON.parse(sessionStorage.getItem("animolife:" + cle) || "null");
      } catch {
        return null;
      }
    },
    ecrire(cle, valeur) {
      try {
        sessionStorage.setItem("animolife:" + cle, JSON.stringify(valeur));
      } catch {
        /* navigation privée : on redemandera */
      }
    },
    oublier(cle) {
      try {
        sessionStorage.removeItem("animolife:" + cle);
      } catch {
        /* rien à oublier */
      }
    },
  };

  // Mesure pour le tableau de bord de l'application. Une visite : ce navigateur, ce jour. L'identifiant, tiré au
  // hasard, n'existe qu'avec l'accord pour la mesure ; sans lui, seule l'arrivée sur le site est comptée.
  // Robots, aperçus de thème, appareils du marchand et pages rechargées sont signalés à part, jamais comme visites.
  const mesure = { id: "", pret: false, attente: [], arrivee: false };
  const mesureEnvoyer = (corps) => {
    try {
      fetch(`${agents}/mesure`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(corps), keepalive: true }).catch(() => {});
    } catch {
      /* la mesure ne casse jamais la boutique */
    }
  };
  const mesurer = (geste, plus = {}) => {
    if (!mesure.pret) mesure.attente.push([geste, plus]);
    else if (mesure.id) mesureEnvoyer({ e: geste, v: mesure.id, ...mesure.contexte, ...plus });
  };
  // Le panier porte la visite : la commande payée, lue dans Shopify, retrouve ainsi d'où elle vient
  const mesureSurPanier = () => {
    if (!mesure.id) return;
    fetch(`${H.routes.racine}cart/update.js`, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ attributes: { _visite: mesure.id } }) })
      .then((r) => r.ok && memoire.ecrire("visite-panier", mesure.id))
      .catch(() => {});
  };
  {
    const adresse = new URLSearchParams(location.search);
    // Le marchand marque ses appareils une fois : ?mesure=moi, et ?mesure=visiteur pour revenir en arrière
    if (adresse.get("mesure") === "moi") stockage.ecrire("moi", true);
    if (adresse.get("mesure") === "visiteur") stockage.ecrire("moi", false);
    const navigation = performance.getEntriesByType?.("navigation")[0]?.type || "navigate";
    let referent = "";
    try {
      referent = document.referrer ? new URL(document.referrer).hostname : "";
    } catch {
      /* référent illisible : origine inconnue */
    }
    const interne = referent === location.hostname;
    mesure.contexte = {
      m: window.matchMedia("(max-width: 767px)").matches,
      r: interne ? "" : referent,
      u: (adresse.get("utm_source") || "").slice(0, 60),
      um: (adresse.get("utm_medium") || (adresse.get("gclid") ? "cpc" : "")).slice(0, 40),
      // La campagne du lien : bio, story, pseudo d'un créateur
      k: (adresse.get("utm_campaign") || "").slice(0, 40),
      p: window.Shopify?.country || "",
      l: H.langue || "",
    };
    const fiche = location.pathname.match(/\/products\/([a-z0-9-]+)/)?.[1] || "";
    const ecart = navigator.webdriver
      ? "robot"
      : window.Shopify?.designMode || (window.Shopify?.theme?.role && window.Shopify.theme.role !== "main")
        ? "apercu"
        : stockage.lire("moi", false)
          ? "soi"
          : "";
    // Une page rechargée, ou retrouvée par le bouton Retour, n'est pas une page vue de plus ; ses gestes, eux, comptent
    const recharge = navigation === "reload" || navigation === "back_forward";
    const signalerRecharge = () => {
      if (!mesure.rechargeDite) mesureEnvoyer({ e: "ecart", x: "recharge" });
      mesure.rechargeDite = true;
    };
    const aujourdhui = new Date().toLocaleDateString("sv");
    const accord = () => Boolean(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.());
    const choisi = () => {
      const suivi = window.Shopify?.customerPrivacy?.getTrackingConsent?.();
      return !window.Shopify?.customerPrivacy?.shouldShowBanner?.() || (suivi && suivi !== "no_interaction");
    };
    const ouvrir = () => {
      if (mesure.pret && (mesure.id || !accord())) return;
      if (ecart) {
        if (!mesure.pret) mesureEnvoyer({ e: "ecart", x: ecart });
        mesure.pret = true;
        mesure.attente = [];
        return;
      }
      if (accord()) {
        let visite = stockage.lire("visite", null);
        const neuve = !visite || visite.j !== aujourdhui || !/^[a-z0-9]{16}$/.test(visite.i || "");
        if (neuve) {
          visite = { i: [...crypto.getRandomValues(new Uint8Array(16))].map((o) => "abcdefghijklmnopqrstuvwxyz0123456789"[o % 36]).join(""), j: aujourdhui };
          stockage.ecrire("visite", visite);
        }
        mesure.id = visite.i;
        // d : avant cet accord, cette session avait déjà compté une arrivée sans identifiant, que le serveur efface
        const doublon = neuve && memoire.lire("arrivee") === aujourdhui;
        memoire.oublier("arrivee");
        if (recharge && !neuve) signalerRecharge();
        else mesureEnvoyer({ e: "vue", v: mesure.id, ...mesure.contexte, f: fiche, d: doublon });
        // Un panier rempli un autre jour reprend la visite d'aujourd'hui, une fois par session
        if (H.panierCompte > 0 && memoire.lire("visite-panier") !== mesure.id) mesureSurPanier();
        const attente = mesure.attente;
        mesure.pret = true;
        mesure.attente = [];
        for (const [geste, plus] of attente) mesurer(geste, plus);
      } else {
        try {
          localStorage.removeItem("animolife:visite");
        } catch {
          /* rien à retirer */
        }
        // Sans accord : une arrivée de l'extérieur compte une visite, sans identifiant ; les pages suivantes ne comptent pas.
        // Elle part tout de suite, sans attendre la réponse au bandeau : si l'accord vient ensuite, le serveur l'efface (d).
        if (recharge) signalerRecharge();
        else if (!mesure.arrivee && !interne) {
          mesureEnvoyer({ e: "vue", ...mesure.contexte });
          memoire.ecrire("arrivee", aujourdhui);
        }
        mesure.arrivee = true;
        // Le visiteur a refusé : ses gestes ne sont pas suivis. Sans réponse encore, ils attendent
        if (choisi()) {
          mesure.pret = true;
          mesure.attente = [];
        }
      }
    };
    // Une page préchargée ou ouverte en arrière-plan n'est pas une page vue : on attend qu'elle s'affiche
    const lancer = () => {
      if (document.visibilityState !== "visible") return document.addEventListener("visibilitychange", lancer, { once: true });
      if (!window.Shopify?.loadFeatures) return ouvrir();
      window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], () => {
        ouvrir();
        // Le bandeau attend une réponse : la visite prend son identifiant dès que l'accord vient
        document.addEventListener("visitorConsentCollected", ouvrir);
      });
    };
    if (document.prerendering) document.addEventListener("prerenderingchange", lancer, { once: true });
    else lancer();
    document.addEventListener("submit", (e) => e.submitter?.name === "checkout" && mesurer("paiement"));
  }
  const pluriel = new Intl.PluralRules(H.langue);
  // Dates et réductions telles que le client les lit : « 30 novembre », « −10 % »
  const dateLisible = (iso, annee = false) =>
    new Intl.DateTimeFormat(H.langue, { day: "numeric", month: "long", ...(annee ? { year: "numeric" } : {}) }).format(new Date(iso.length === 10 ? `${iso}T12:00:00` : iso));
  const offreTexte = (c) =>
    c.pourcent ? remplir(T.remise, { n: c.pourcent }) : new Intl.NumberFormat(H.langue, { style: "currency", currency: window.Shopify?.currency?.active || "EUR" }).format(c.montant || 0);
  // Un prénom ou un pseudonyme, mêmes règles que le serveur (avis.py, espace.py)
  const nomPermis = /^[\p{L}\p{N}_ .'’-]+$/u;
  // Même règle que la feuille de style (:root:not([data-theme="dark"])) : tout ce qui n'est pas la laque est clair
  const themeClair = () => document.documentElement.dataset.theme !== "dark";
  // Ni lien ni adresse e-mail dans un avis publié, même règle que le serveur (avis.py)
  const lienInterdit = /(https?:\/\/|www\.)|[\p{L}\p{N}_.+-]+@[\p{L}\p{N}_-]+\.[\p{L}\p{N}_]|(^|[^\p{L}\p{N}_-])[\p{L}\p{N}_-]+\.(com|fr|net|org|io|ly|co|shop|store|xyz|info|biz|me|link|app|site|online|eu|be|ch|ca)(?![\p{L}\p{N}_])/iu;
  // Message sous le champ et état du champ ; rend vrai si le champ est fautif
  const signaler = (id, faux, champ) => {
    document.getElementById(id).hidden = !faux;
    if (champ) faux ? champ.setAttribute("aria-invalid", "true") : champ.removeAttribute("aria-invalid");
    return faux;
  };

  /* --- Notification --- */
  let minuteurToast = 0;
  function toast(message) {
    const el = $("#toast");
    if (!el) return;
    // Une fenêtre modale recouvre la page : la notification s'affiche dedans tant qu'elle est ouverte
    const hote = $("dialog[open]") || document.body;
    if (el.parentElement !== hote) hote.append(el);
    el.textContent = message;
    el.dataset.open = "true";
    clearTimeout(minuteurToast);
    minuteurToast = setTimeout(() => (el.dataset.open = "false"), 2600);
  }

  /* --- Pays de livraison --- */
  // Langue et pays : le choix part dès qu'il change
  for (const liste of $$("[data-langue] select")) liste.addEventListener("change", () => liste.form.submit());

  // La liste des pays se referme d'un clic ailleurs ou à Échap, et s'ouvre depuis « Changer de pays »
  const menusPays = $$(".pays-menu");
  document.addEventListener("click", (e) => {
    for (const menu of menusPays) if (!menu.contains(e.target)) menu.open = false;
    const lien = e.target.closest?.('a[href="#ft-pays"]');
    if (lien && $("#ft-pays")) $("#ft-pays").open = true;
  });
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    for (const menu of menusPays) {
      if (!menu.open) continue;
      menu.open = false;
      $("summary", menu).focus();
    }
  });

  // Après la bascule, une ligne sous l'en-tête le dit, avec de quoi changer
  const avisPays = $("[data-pays-avis]");
  try {
    if (avisPays && sessionStorage.getItem("animolife:pays-bascule")) {
      sessionStorage.removeItem("animolife:pays-bascule");
      avisPays.hidden = false;
    }
  } catch {
    // Sans mémoire de session, pas d'avis : le pays reste visible dans l'en-tête et le pied de page
  }
  $("[data-pays-avis-fermer]")?.addEventListener("click", () => (avisPays.hidden = true));

  // Le pays de livraison suit celui que Shopify devine pour le visiteur, une seule fois : ensuite son choix dans la liste fait foi
  (async () => {
    const menu = menusPays[0];
    if (!menu) return;
    try {
      if (localStorage.getItem("animolife:pays")) return;
      const reponse = await fetch(`${H.routes.racine}browsing_context_suggestions.json?country[enabled]=true`);
      const pays = (await reponse.json()).detected_values?.country?.handle;
      localStorage.setItem("animolife:pays", pays || "inconnu");
      // Dans un pays à plusieurs langues, la ligne qui parle celle du navigateur ; sinon la langue du pays
      const lignes = pays ? $$("button[name=country_code]", menu).filter((b) => b.value === pays) : [];
      const langueNavigateur = (navigator.language || "").slice(0, 2).toLowerCase();
      const bouton = lignes.find((b) => b.dataset.locale.slice(0, 2) === langueNavigateur) || lignes[0];
      // Même pays : la langue ne change que pour quitter le français par défaut, jamais une langue choisie par l'adresse
      const autreLangue = lignes.length > 1 && menu.dataset.locale === "fr" && bouton?.dataset.locale !== "fr";
      if (bouton && (pays !== menu.dataset.pays || autreLangue)) {
        // La page suivante dira au visiteur que le site s'est placé dans son pays
        sessionStorage.setItem("animolife:pays-bascule", "1");
        bouton.click();
      }
    } catch {
      // Sans mémoire locale ou sans réponse, le pays reste celui de la boutique
    }
  })();

  /* --- Thème clair ou sombre (useTheme.js) --- */
  const COULEUR_BARRE = { light: "#f6f5fc", dark: "#0a0a0a" };
  const systeme = window.matchMedia?.("(prefers-color-scheme: dark)");
  function themeCourant() {
    let choix = null;
    try {
      choix = localStorage.getItem("animolife:theme");
    } catch {
      /* rien */
    }
    if (choix === "light" || choix === "dark") return choix;
    // Sans choix du client : le thème de la boutique, la laque par défaut, ou celui de l'appareil
    if (H.themeDefaut === "clair") return "light";
    if (H.themeDefaut !== "systeme") return "dark";
    return systeme?.matches ? "dark" : "light";
  }
  function appliquerTheme(theme) {
    const racine = document.documentElement;
    // Changer de thème ne fait rien bouger : transitions coupées le temps d'une image
    racine.classList.add("no-transition");
    racine.dataset.theme = theme;
    requestAnimationFrame(() => racine.classList.remove("no-transition"));
    for (const balise of $$('meta[name="theme-color"]')) {
      balise.removeAttribute("media");
      balise.setAttribute("content", COULEUR_BARRE[theme]);
    }
    const sombre = theme === "dark";
    for (const bouton of $$("[data-bascule-theme]")) {
      if (!bouton.closest(".menu-row")) bouton.setAttribute("aria-label", sombre ? T.themeClair : T.themeSombre);
      $(".picto-theme", bouton)?.classList.toggle("is-dark", sombre);
    }
    for (const libelle of $$("[data-libelle-theme]")) libelle.textContent = sombre ? T.themeClairCourt : T.themeSombreCourt;
  }
  appliquerTheme(themeCourant());
  systeme?.addEventListener("change", () => appliquerTheme(themeCourant()));
  document.addEventListener("click", (e) => {
    if (!e.target.closest("[data-bascule-theme]")) return;
    const suivant = themeCourant() === "dark" ? "light" : "dark";
    try {
      localStorage.setItem("animolife:theme", suivant);
    } catch {
      /* rien */
    }
    appliquerTheme(suivant);
  });

  /* --- Feuilles : menu et panier (MenuSheet, CartDrawer, useFocusTrap) --- */
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  let feuilleOuverte = null;
  let focusAvant = null;

  function verrouiller(oui) {
    const racine = document.documentElement;
    if (oui) {
      racine.style.setProperty("--barre-defilement", `${window.innerWidth - racine.clientWidth}px`);
      racine.dataset.verrou = "";
    } else {
      delete racine.dataset.verrou;
    }
  }
  // Les images en attente (data-srcset) d'un bloc partent quand on en a besoin : case touchée, feuille ouverte
  function armerImages(bloc) {
    for (const img of $$("img[data-srcset]", bloc)) {
      img.sizes = img.dataset.sizes;
      img.srcset = img.dataset.srcset;
      img.removeAttribute("data-srcset");
    }
  }
  function ouvrirFeuille(id) {
    const feuille = document.getElementById(id);
    if (!feuille) return;
    armerImages(feuille);
    // D'une feuille à l'autre (combo puis panier), le focus revient au bouton d'origine
    if (feuilleOuverte && feuilleOuverte !== feuille) {
      const origine = focusAvant;
      fermerFeuille(false);
      focusAvant = origine;
    } else {
      focusAvant = document.activeElement;
    }
    feuilleOuverte = feuille;
    feuille.dataset.open = "true";
    feuille.removeAttribute("inert");
    $(`[data-voile="${id}"]`)?.setAttribute("data-open", "true");
    verrouiller(true);
    requestAnimationFrame(() => $$(FOCUSABLE, feuille).find((el) => el.offsetParent)?.focus());
  }
  function fermerFeuille(rendreFocus = true) {
    const feuille = feuilleOuverte;
    if (!feuille) return;
    feuille.dataset.open = "false";
    feuille.setAttribute("inert", "");
    $(`[data-voile="${feuille.id}"]`)?.setAttribute("data-open", "false");
    feuilleOuverte = null;
    verrouiller(false);
    if (rendreFocus && focusAvant instanceof HTMLElement && document.contains(focusAvant)) focusAvant.focus();
  }
  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-ouvre-menu]")) {
      ouvrirFeuille("menu");
    } else if (e.target.closest("[data-ouvre-panier]") && $("#panier")) {
      e.preventDefault();
      ouvrirFeuille("panier");
    } else if (e.target.closest("[data-ferme]") || e.target.matches(".scrim[data-open='true']")) {
      fermerFeuille();
    }
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && feuilleOuverte) fermerFeuille();
    if (e.key !== "Tab" || !feuilleOuverte) return;
    const items = $$(FOCUSABLE, feuilleOuverte).filter((el) => el.offsetParent);
    if (!items.length) return;
    const premier = items[0];
    const dernier = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === premier || !feuilleOuverte.contains(document.activeElement))) {
      e.preventDefault();
      dernier.focus();
    } else if (!e.shiftKey && document.activeElement === dernier) {
      e.preventDefault();
      premier.focus();
    }
  });

  /* --- Panier : l'API Ajax de Shopify et le rendu des sections --- */
  async function rafraichirPanier(sections) {
    const html = sections?.["panier-tiroir"];
    if (html) {
      const doc = new DOMParser().parseFromString(html, "text/html");
      const neuve = $("#panier", doc);
      const actuelle = $("#panier");
      if (neuve && actuelle) {
        const ouverte = actuelle.dataset.open === "true";
        actuelle.innerHTML = neuve.innerHTML;
        if (ouverte) {
          actuelle.dataset.open = "true";
          actuelle.removeAttribute("inert");
        }
      }
    }
    const panier = await fetch(`${H.routes.panier}.js`).then((r) => r.json());
    for (const compte of $$("[data-compte-panier]")) {
      compte.textContent = panier.item_count;
      compte.hidden = panier.item_count === 0;
    }
    remplirDatesLivraison();
    suivreGrattage(panier);
    lancerMinuteurs();
    return panier;
  }
  async function ajouterAuPanier(id, quantite = 1) {
    // Achat suspendu dans les réglages du thème : rien ne part au panier
    if (H.venteSuspendue) throw new Error(T.bientot);
    const reponse = await fetch(`${H.routes.panierAjout}.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      // Plusieurs objets d'un geste : « 123,456 » les ajoute chacun en même quantité
      body: JSON.stringify({ items: String(id).split(",").map((v) => ({ id: Number(v), quantity: quantite })), sections: "panier-tiroir" }),
    });
    const donnees = await reponse.json();
    if (!reponse.ok) throw new Error(donnees.description || donnees.message || T.erreurPanier);
    mesurer("panier");
    mesureSurPanier();
    return rafraichirPanier(donnees.sections);
  }
  async function changerQuantite(cle, quantite) {
    const feuille = $("#panier");
    feuille?.setAttribute("aria-busy", "true");
    try {
      const reponse = await fetch(`${H.routes.panierChange}.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: cle, quantity: quantite, sections: "panier-tiroir" }),
      });
      const donnees = await reponse.json();
      if (!reponse.ok) throw new Error(donnees.description || T.erreurPanier);
      if ($("[data-panier-page]")) return location.reload();
      await rafraichirPanier(donnees.sections);
    } catch (err) {
      toast(err.message || T.erreurPanier);
    } finally {
      feuille?.removeAttribute("aria-busy");
    }
  }
  document.addEventListener("click", (e) => {
    const bouton = e.target.closest("[data-quantite]");
    if (!bouton) return;
    const ligne = bouton.closest("[data-ligne]");
    if (ligne) changerQuantite(ligne.dataset.ligne, Number(bouton.dataset.quantite));
  });

  /* --- Combo : ce qui va avec l'objet ajouté, dans une feuille (section combo.liquid) --- */
  const combos = new Map();
  let combosVus = [];
  try {
    combosVus = JSON.parse(sessionStorage.getItem("animolife:combos") || "[]");
  } catch {
    /* navigation privée : la feuille peut revenir */
  }
  const lireCombo = (url) =>
    fetch(url)
      .then((r) => (r.ok ? r.text() : ""))
      .then((html) => $("[data-combo-contenu]", new DOMParser().parseFromString(html, "text/html")));
  // Le champ « Combo » de l'objet d'abord, les produits complémentaires de Shopify ensuite
  function chargerCombo(handle, id) {
    if (!combos.has(handle)) {
      const promesse = lireCombo(`${H.routes.racine}products/${handle}?section_id=combo`)
        .then((c) => c || (id ? lireCombo(`${H.routes.racine}recommendations/products?product_id=${id}&intent=complementary&limit=4&section_id=combo`) : null))
        .catch(() => null);
      combos.set(handle, promesse);
    }
    return combos.get(handle);
  }
  // Rend vrai si la feuille s'ouvre ; une fois par objet et par visite, sans ce qui est déjà au panier
  async function proposerCombo(handle, id, panier) {
    if (!handle || combosVus.includes(handle) || !$("#combo")) return false;
    const contenu = await chargerCombo(handle, id);
    if (!contenu) return false;
    const copie = contenu.cloneNode(true);
    const dejaLa = new Set((panier?.items || []).map((i) => i.handle));
    for (const li of $$("[data-combo-objet]", copie)) if (dejaLa.has(li.dataset.comboObjet)) li.remove();
    if (!$("[data-combo-objet]", copie)) return false;
    combosVus.push(handle);
    try {
      sessionStorage.setItem("animolife:combos", JSON.stringify(combosVus));
    } catch {
      /* rien */
    }
    $("#combo").replaceChildren(copie);
    ouvrirFeuille("combo");
    publier("complement_propose", { objet: handle });
    return true;
  }
  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-vers-panier]")) ouvrirFeuille("panier");
  });

  // Accueil en page de vente : la barre d'achat paraît quand le bouton de l'ouverture est passé
  const achatVitrine = $("[data-achat-vitrine]");
  const barreVitrine = $("[data-barre-vitrine]");
  if (achatVitrine && barreVitrine && "IntersectionObserver" in window) {
    new IntersectionObserver(([entree]) => {
      const visible = !entree.isIntersecting && entree.boundingClientRect.top < 0;
      barreVitrine.toggleAttribute("data-visible", visible);
      barreVitrine.inert = !visible;
    }).observe(achatVitrine);
  }

  // Combien doit-il boire : environ 50 ml par kilo et par jour, nourriture comprise
  const nombre = new Intl.NumberFormat(document.documentElement.lang || "fr");
  const rebond = (el) => {
    el.classList.remove("vt-bond");
    void el.offsetWidth;
    el.classList.add("vt-bond");
  };
  // Sur téléphone seulement : sur ordinateur, les mêmes tuiles sont déjà dans la plaque, à côté de la photo
  const modeleBesoin = $("template[data-fiche-besoin]");
  if (modeleBesoin && window.matchMedia("(max-width: 55.99rem)").matches) {
    $("[data-fiche-besoin-place]")?.append(modeleBesoin.content.cloneNode(true));
  }
  for (const calcul of document.querySelectorAll("[data-calcul]")) {
    const curseur = $("[data-calcul-curseur]", calcul);
    const poids = $("[data-calcul-poids]", calcul);
    const ml = $("[data-calcul-ml]", calcul);
    const texte = $("[data-calcul-texte]", calcul);
    const calculer = () => {
      const kg = Number(curseur.value);
      poids.textContent = `${nombre.format(kg)} kg`;
      const valeur = `${nombre.format(Math.round((kg * 50) / 10) * 10)} ml`;
      if (ml.textContent !== valeur) {
        ml.textContent = valeur;
        rebond(ml);
      }
      texte.textContent = texte.dataset[$("input[type=radio]:checked", calcul)?.value || "sec"];
    };
    calcul.addEventListener("input", calculer);
    calcul.addEventListener("change", calculer);
    calculer();
  }

  // L'en-tête : la pastille glisse sous la rubrique pointée et revient sur la rubrique ouverte
  const navGlisse = $("[data-nav-glisse]");
  if (navGlisse) {
    const pastille = $(".hd-glisse", navGlisse);
    const ouverte = () => $('a[aria-current="page"]', navGlisse);
    const poser = (lien) => {
      if (!lien || !lien.offsetWidth) {
        pastille.removeAttribute("data-visible");
        return;
      }
      pastille.style.setProperty("--glisse-x", `${lien.offsetLeft}px`);
      pastille.style.setProperty("--glisse-l", `${lien.offsetWidth}px`);
      pastille.setAttribute("data-visible", "");
    };
    navGlisse.addEventListener("pointerover", (e) => poser(e.target.closest("a")));
    navGlisse.addEventListener("pointerleave", () => poser(ouverte()));
    navGlisse.addEventListener("focusin", (e) => poser(e.target.closest("a")));
    navGlisse.addEventListener("focusout", () => poser(ouverte()));
    // La première pose se fait sur place, une fois les polices et l'onglet Chats ou Chiens posés
    const poserSurPlace = () => {
      pastille.style.transition = "none";
      poser(ouverte());
      void pastille.offsetWidth;
      pastille.style.removeProperty("transition");
    };
    setTimeout(poserSurPlace, 0);
    document.fonts?.ready.then(poserSurPlace);
    addEventListener("resize", poserSurPlace);
  }

  // « Boutique » ouvre son panneau au survol ou au clavier ; il se referme en quittant l'en-tête ou avec Échap
  const panneau = $("[data-panneau]");
  const ouvrePanneau = $("[data-ouvre-panneau]");
  if (panneau && ouvrePanneau) {
    const entete = ouvrePanneau.closest(".hd");
    let minuterie;
    let sansRouvrir = false;
    const ouvrir = () => {
      clearTimeout(minuterie);
      if (sansRouvrir || !matchMedia("(min-width: 64rem)").matches || panneau.hasAttribute("data-ouvert")) return;
      panneau.hidden = false;
      // Une lecture de taille fait partir la transition depuis l'état fermé
      void panneau.offsetWidth;
      panneau.setAttribute("data-ouvert", "");
      ouvrePanneau.setAttribute("aria-expanded", "true");
    };
    const fermer = (aussitot) => {
      clearTimeout(minuterie);
      minuterie = setTimeout(() => {
        panneau.removeAttribute("data-ouvert");
        ouvrePanneau.setAttribute("aria-expanded", "false");
        setTimeout(() => {
          if (!panneau.hasAttribute("data-ouvert")) panneau.hidden = true;
        }, 300);
      }, aussitot ? 0 : 180);
    };
    ouvrePanneau.addEventListener("pointerenter", () => {
      clearTimeout(minuterie);
      minuterie = setTimeout(ouvrir, 90);
    });
    ouvrePanneau.addEventListener("focus", ouvrir);
    panneau.addEventListener("pointerenter", () => clearTimeout(minuterie));
    entete.addEventListener("pointerleave", () => fermer());
    navGlisse?.addEventListener("pointerover", (e) => {
      const lien = e.target.closest("a");
      if (lien && lien !== ouvrePanneau) fermer();
    });
    entete.addEventListener("focusout", (e) => {
      if (!entete.contains(e.relatedTarget)) fermer(true);
    });
    document.addEventListener("keydown", (e) => {
      if (e.key !== "Escape" || !panneau.hasAttribute("data-ouvert")) return;
      fermer(true);
      sansRouvrir = true;
      ouvrePanneau.focus();
      sansRouvrir = false;
    });
  }

  // Le champ du conseiller grandit avec son texte, là où le navigateur ne sait pas le faire seul (Safari)
  const champConseil = $("#conseil-champ");
  if (champConseil && !CSS.supports("field-sizing", "content")) {
    const ajuster = () => {
      champConseil.style.height = "auto";
      champConseil.style.height = `${Math.min(champConseil.scrollHeight, 144)}px`;
    };
    champConseil.addEventListener("input", ajuster);
  }

  // Le compteur du panier rebondit quand il change
  for (const compte of document.querySelectorAll("[data-compte-panier]")) {
    new MutationObserver(() => rebond(compte)).observe(compte, { childList: true, characterData: true, subtree: true });
  }

  // Ajout depuis une case : « Ajouté », puis le combo s'il y en a un ; dans le combo, le bouton reste « Ajouté »
  document.addEventListener("click", async (e) => {
    const bouton = e.target.closest("[data-ajout]");
    if (!bouton) return;
    const dansCombo = Boolean(bouton.closest("#combo"));
    const origine = bouton.closest("[data-case]");
    bouton.disabled = true;
    try {
      const panier = await ajouterAuPanier(bouton.dataset.ajout, 1);
      const swap = $(".swap", bouton);
      if (swap) swap.dataset.state = "done";
      if (dansCombo) {
        bouton.setAttribute("aria-label", T.ajoute);
        publier("complement_accepte", { variante: bouton.dataset.ajout });
        return;
      }
      if (swap) setTimeout(() => (swap.dataset.state = "idle"), 1600);
      if (origine) await proposerCombo(origine.dataset.handle, origine.dataset.id, panier);
      bouton.disabled = false;
    } catch (err) {
      toast(err.message);
      bouton.disabled = false;
    }
  });

  /* --- Date de livraison (delivery.js) --- */
  const joursOuvresPlus = (depart, n) => {
    const date = new Date(depart);
    let reste = n;
    while (reste > 0) {
      date.setDate(date.getDate() + 1);
      const j = date.getDay();
      if (j !== 0 && j !== 6) reste -= 1;
    }
    return date;
  };
  function remplirDatesLivraison() {
    const cibles = $$("[data-date-livraison]");
    if (!cibles.length) return;
    const limite = Number(H.livraison.heureLimite) || 15;
    const transit = Number(H.livraison.joursTransit) || 2;
    const maintenant = new Date();
    const jour = maintenant.getDay();
    const avant = jour !== 0 && jour !== 6 && maintenant.getHours() < limite;
    const texte = new Intl.DateTimeFormat(H.langue, { weekday: "long", day: "numeric", month: "long" }).format(joursOuvresPlus(maintenant, (avant ? 1 : 2) + transit));
    const phrase = avant ? remplir(T.livraisonAvant, { date: texte, hour: limite }) : remplir(T.livraisonLe, { date: texte });
    const jourMois = new Intl.DateTimeFormat(H.langue, { day: "numeric", month: "long" });
    for (const c of cibles) {
      // Un objet qui a ses propres délais, ceux de son option d'expédition, donne une fourchette en jours ouvrés
      const max = Number(c.dataset.delaiMax) || 0;
      if (!max) {
        c.textContent = phrase;
        continue;
      }
      const min = Math.min(Number(c.dataset.delaiMin) || max, max);
      c.textContent = remplir(T.livraisonEntre, { debut: jourMois.format(joursOuvresPlus(maintenant, min)), fin: jourMois.format(joursOuvresPlus(maintenant, max)) });
    }
  }
  remplirDatesLivraison();

  /* --- Favoris (useWishlist) --- */
  const favoris = new Set(stockage.lire("wishlist", []));
  function peindreFavoris() {
    for (const bouton of $$("[data-favori]")) {
      const oui = favoris.has(bouton.dataset.favori);
      bouton.setAttribute("aria-pressed", String(oui));
      bouton.setAttribute("aria-label", oui ? bouton.dataset.libelleRetrait : bouton.dataset.libelleAjout);
      const coeur = $(".picto-coeur", bouton);
      if (coeur) {
        coeur.setAttribute("fill", oui ? "var(--accent)" : "none");
        coeur.setAttribute("stroke", oui ? "var(--accent)" : "currentColor");
      }
    }
    for (const compte of $$("[data-compte-favoris]")) {
      compte.textContent = favoris.size;
      compte.hidden = favoris.size === 0;
    }
    for (const lien of $$("[data-lien-favoris] .picto-coeur")) {
      lien.setAttribute("fill", favoris.size ? "var(--accent)" : "none");
      lien.setAttribute("stroke", favoris.size ? "var(--accent)" : "currentColor");
    }
  }
  document.addEventListener("click", (e) => {
    const bouton = e.target.closest("[data-favori]");
    if (!bouton) return;
    const handle = bouton.dataset.favori;
    if (favoris.has(handle)) {
      favoris.delete(handle);
      toast(T.favRetrait);
    } else {
      favoris.add(handle);
      toast(T.favAjout);
    }
    stockage.ecrire("wishlist", [...favoris]);
    peindreFavoris();
    rendreFavoris();
  });
  function rendreFavoris() {
    const liste = $("[data-favoris-liste]");
    const modele = $("[data-favoris-cases]");
    if (!liste || !modele) return;
    liste.innerHTML = "";
    for (const c of $$("[data-case]", modele.content)) {
      if (favoris.has(c.dataset.handle)) liste.append(c.cloneNode(true));
    }
    liste.hidden = liste.children.length === 0;
    $("[data-favoris-vide]").hidden = liste.children.length > 0;
    peindreFavoris();
  }
  rendreFavoris();
  peindreFavoris();

  /* --- Photos d'une case : le point et la flèche suivent le ruban, aussi pour les cases ajoutées après coup --- */
  const marquerVue = (ruban) => {
    const i = Math.round(ruban.scrollLeft / Math.max(1, ruban.clientWidth));
    const art = ruban.parentElement;
    $$(".case-vue", ruban).forEach((v, n) => v.classList.toggle("est-vue", n === i));
    $$(".case-points span", art).forEach((p, n) => p.classList.toggle("est-vue", n === i));
    const prec = $(".case-fleche-prec", art);
    const suiv = $(".case-fleche-suiv", art);
    if (prec) prec.disabled = i <= 0;
    if (suiv) suiv.disabled = i >= ruban.children.length - 1;
  };
  // Seule la première photo d'une case part avec la page : les autres attendent le premier geste sur la case
  const armerCase = (e) => {
    const boite = e.target instanceof Element && e.target.closest("[data-case]");
    if (boite) armerImages(boite);
  };
  for (const geste of ["pointerover", "touchstart", "focusin"]) document.addEventListener(geste, armerCase, { passive: true });
  let rubanAttendu = null;
  document.addEventListener(
    "scroll",
    (e) => {
      const ruban = e.target;
      if (!(ruban instanceof Element) || !ruban.matches("[data-defile]") || rubanAttendu) return;
      rubanAttendu = requestAnimationFrame(() => {
        rubanAttendu = null;
        marquerVue(ruban);
      });
    },
    { capture: true, passive: true },
  );
  document.addEventListener("click", (e) => {
    const fleche = e.target.closest("[data-defile-pas]");
    if (!fleche) return;
    e.preventDefault();
    const ruban = $("[data-defile]", fleche.parentElement);
    ruban?.scrollBy({ left: Number(fleche.dataset.defilePas) * ruban.clientWidth, behavior: "smooth" });
  });

  /* --- Code promo du panier (PromoField.jsx) : Shopify valide, le panier se redessine --- */
  async function poserCode(code) {
    const avant = code
      ? await fetch(`${H.routes.panier}.js`)
          .then((r) => r.json())
          .then((p) => (p.discount_codes || []).filter((d) => d.applicable).map((d) => d.code))
          .catch(() => [])
      : [];
    const envoyer = (discount) =>
      fetch(`${H.routes.racine}cart/update.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ discount, sections: "panier-tiroir" }),
      }).then((r) => r.json());
    let donnees = await envoyer(code);
    // Un code refusé ne reste pas accroché au panier : les codes d'avant reviennent, le refus s'écrit sous le champ
    const refuse = code && (donnees.discount_codes || []).some((d) => d.code.toLowerCase() === code.toLowerCase() && !d.applicable);
    if (refuse) donnees = await envoyer(avant.join(","));
    if ($("[data-panier-page]") && !refuse) return location.reload();
    await rafraichirPanier(donnees.sections);
    if (refuse) {
      const erreur = $("#promo-err");
      if (erreur) {
        erreur.textContent = remplir(T.codeRefuse, { code });
        erreur.hidden = false;
        $("#promo-champ")?.setAttribute("aria-invalid", "true");
        if ($("#promo-champ")) $("#promo-champ").value = code;
      } else toast(remplir(T.codeRefuse, { code }));
    }
    $("#promo-champ")?.focus();
  }
  document.addEventListener("submit", (e) => {
    const form = e.target.closest("[data-promo]");
    if (!form) return;
    e.preventDefault();
    const code = form.elements.code.value.trim();
    if (code) poserCode(code).catch(() => toast(T.erreurPanier));
  });
  document.addEventListener("click", (e) => {
    const bouton = e.target.closest("[data-promo-code]");
    if (bouton) poserCode(bouton.dataset.promoCode).catch(() => toast(T.erreurPanier));
    if (e.target.closest("[data-promo-retrait]")) poserCode("").catch(() => {});
  });

  /* --- Minuteur de l'offre (minuteur-offre.liquid) : le temps qui reste vraiment au code de la carte --- */
  // L'échéance vient du serveur avec le code ; sans elle, pas de compte à rebours : jamais un minuteur inventé
  const deuxChiffres = (n) => String(n).padStart(2, "0");
  let minuteurOffre = 0;
  function peindreMinuteurs() {
    const garde = stockage.lire("grattage-code", null);
    let actifs = 0;
    for (const m of $$("[data-minuteur-offre]")) {
      if (!garde || garde.code.toUpperCase() !== m.dataset.code.toUpperCase()) continue;
      const reste = Math.max(0, Math.ceil((Date.parse(garde.fin) - Date.now()) / 1000));
      const texte = $("[data-minuteur-texte]", m);
      if (reste > 0) {
        actifs += 1;
        texte.textContent = remplir(T.offreMinuteur, { temps: `${deuxChiffres(Math.floor(reste / 60))}:${deuxChiffres(reste % 60)}`, offre: garde.offre });
        m.toggleAttribute("data-urgent", reste <= 60);
      } else if (!m.hasAttribute("data-fini")) {
        m.setAttribute("data-fini", "");
        m.removeAttribute("data-urgent");
        texte.textContent = remplir(T.offreFinie, { code: m.dataset.code });
        retirerCodeExpire(m.dataset.code);
      }
    }
    return actifs > 0;
  }
  function lancerMinuteurs() {
    clearInterval(minuteurOffre);
    if (peindreMinuteurs()) {
      minuteurOffre = setInterval(() => {
        if (!peindreMinuteurs()) clearInterval(minuteurOffre);
      }, 1000);
    }
  }
  // Expiré, le code quitte le panier : Shopify le refuserait au paiement, les autres codes restent
  async function retirerCodeExpire(code) {
    try {
      const panier = await fetch(`${H.routes.panier}.js`).then((r) => r.json());
      const autres = (panier.discount_codes || []).map((d) => d.code).filter((c) => c.toUpperCase() !== code.toUpperCase());
      const reponse = await fetch(`${H.routes.racine}cart/update.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ discount: autres.join(","), sections: "panier-tiroir" }),
      });
      if ($("[data-panier-page]")) return location.reload();
      await rafraichirPanier((await reponse.json()).sections);
      // Le bandeau part avec le code : la notification dit pourquoi le total a changé
      toast(remplir(T.offreFinie, { code }));
    } catch {
      /* le code reste affiché comme expiré ; Shopify le refusera au paiement */
    }
  }
  lancerMinuteurs();

  /* --- Photo d'un client, réduite dans le navigateur : 1600 px suffisent (avis de la fiche et questionnaire) --- */
  const photoEnDonnees = async (fichier) => {
    const image = await createImageBitmap(fichier);
    const echelle = Math.min(1, 1600 / Math.max(image.width, image.height));
    const toile = document.createElement("canvas");
    toile.width = Math.round(image.width * echelle);
    toile.height = Math.round(image.height * echelle);
    toile.getContext("2d").drawImage(image, 0, 0, toile.width, toile.height);
    return toile.toDataURL("image/jpeg", 0.85);
  };

  /* --- Bandeau de série limitée : le compte à rebours mène à la vraie fin, puis le bandeau s'efface --- */
  const serie = $("[data-serie]");
  if (serie) {
    const fin = Number(serie.dataset.fin) * 1000;
    const compte = $("[data-serie-compte]", serie);
    const deux = (n) => String(n).padStart(2, "0");
    const dessiner = () => {
      const reste = fin - Date.now();
      if (reste <= 0) {
        serie.remove();
        return false;
      }
      const s = Math.floor(reste / 1000);
      const j = Math.floor(s / 86400);
      const h = Math.floor((s % 86400) / 3600);
      const m = Math.floor((s % 3600) / 60);
      const U = T.unites;
      const duree = j > 0 ? `${j} ${U.j} ${deux(h)} ${U.h}` : h > 0 ? `${h} ${U.h} ${deux(m)} ${U.min}` : `${m} ${U.min} ${deux(s % 60)} ${U.s}`;
      compte.textContent = remplir(T.finDans, { duree });
      return true;
    };
    if (dessiner()) {
      // À la seconde près sous l'heure, à la minute sinon
      const tic = () => {
        if (!dessiner()) return;
        setTimeout(tic, fin - Date.now() < 3600000 ? 1000 : 30000);
      };
      setTimeout(tic, 1000);
    }
  }

  /* --- Offrir une réduction à un ami : la feuille de partage du téléphone, sinon le lien copié --- */
  // Le lien de parrainage naît au premier partage (codes.py), puis la page le connaît
  const lienParrainage = (code) => `${location.origin}${H.routes.racine}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(H.routes.racine)}`;
  document.addEventListener("click", async (e) => {
    const bouton = e.target.closest("[data-partage-ami]");
    if (!bouton) return;
    if (!bouton.dataset.lien) {
      bouton.disabled = true;
      try {
        const r = await fetch(`${agents}/parrainage`, { method: "POST" });
        if (!r.ok) throw new Error(String(r.status));
        const lien = lienParrainage((await r.json()).code);
        for (const b of $$("[data-partage-ami]")) b.dataset.lien = lien;
        memoire.oublier("espace");
      } catch {
        toast(T.lienErreur);
        return;
      } finally {
        bouton.disabled = false;
      }
    }
    const donnees = { title: bouton.dataset.titre, text: bouton.dataset.texte, url: bouton.dataset.lien };
    try {
      if (navigator.share) {
        await navigator.share(donnees);
      } else {
        await navigator.clipboard.writeText(donnees.url);
        toast(T.lienCopie);
      }
    } catch (err) {
      // Après l'attente du serveur, le navigateur peut exiger un nouveau geste : le lien est prêt pour le suivant
      if (err?.name === "NotAllowedError") toast(T.lienPret);
    }
  });

  /* --- Le plus populaire (populaire.py) : les ventes réelles, lues une fois par visite ; le nombre d'objets marqués se règle dans le thème --- */
  // Une seule requête par page : les marques et les objets mis en avant partagent la même promesse
  let populaireEnCours = null;
  function lirePopulaire() {
    populaireEnCours ??= (async () => {
      const garde = memoire.lire("populaire");
      if (garde && Date.now() - garde.t < 60 * 60 * 1000) return garde.p;
      const r = await fetch(`${agents}/populaire`);
      if (!r.ok) return null;
      const p = await r.json();
      memoire.ecrire("populaire", { t: Date.now(), p });
      return p;
    })();
    return populaireEnCours;
  }
  if ($("[data-marques]")) {
    lirePopulaire()
      .then((p) => {
        if (!p) return;
        // Les objets les plus commandés, autant que la boutique en a choisi ; à égalité, tous
        const tries = Object.entries(p.ventes || {}).sort((a, b) => b[1] - a[1]);
        const limite = tries[Math.min(H.populaireNombre || 1, tries.length) - 1]?.[1];
        const populaires = new Set(tries.filter(([, n]) => n >= limite).map(([h]) => h));
        if (populaires.size) {
          for (const bloc of $$("[data-marques]")) {
            const handle = bloc.dataset.marquesHandle || bloc.closest("[data-case]")?.dataset.handle;
            if (!populaires.has(handle) || $(".marque-populaire", bloc)) continue;
            const marque = document.createElement("span");
            marque.className = "marque-populaire";
            marque.textContent = T.populaire;
            bloc.prepend(marque);
          }
        }
        // Sur la fiche, le nombre de commandes de l'objet, dès la première
        const ligne = $("[data-ventes]");
        const fiche = $("[data-marques-handle]");
        const n = fiche && p.ventes?.[fiche.dataset.marquesHandle];
        if (ligne && n) {
          ligne.textContent = remplir(T.populaireVentes[pluriel.select(n)] || T.populaireVentes.other, { n, j: p.jours });
          ligne.hidden = false;
        }
      })
      .catch(() => {
        /* serveur endormi : la page reste telle quelle */
      });
  }

  /* --- Radar des envies (radar.py) : une recherche sans réponse, comptée une fois par visite --- */
  function envoyerRadar(terme) {
    const t = String(terme || "").trim().toLowerCase().slice(0, 80);
    const vus = memoire.lire("radar") || [];
    if (t.length < 3 || vus.includes(t)) return;
    memoire.ecrire("radar", [...vus, t].slice(-30));
    fetch(`${agents}/radar`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ terme: t }),
      keepalive: true,
    }).catch(() => {});
  }
  const rechercheVide = $("[data-radar]");
  if (rechercheVide) envoyerRadar(rechercheVide.dataset.radar);

  /* --- Espace du client connecté (espace.py) : tampons, codes, anniversaire, avis à donner, parrainage --- */

  async function lireEspace(fraiche = false) {
    const garde = memoire.lire("espace");
    if (!fraiche && garde && Date.now() - garde.t < 30 * 60 * 1000) return garde.e;
    const r = await fetch(`${agents}/moi`);
    if (!r.ok) return garde?.e ?? null;
    const e = await r.json();
    if (e.connecte) memoire.ecrire("espace", { t: Date.now(), e });
    return e;
  }

  function peindreTampons(e) {
    const t = e.tampons;
    if (!t) return;
    const offre = e.codes.find((c) => c.type === "tampons" && c.carte === t.cartes);
    let remplis = t.total % t.par_carte;
    if (remplis === 0 && t.cartes > 0) remplis = t.par_carte;
    const reste = t.par_carte - remplis;
    for (const bloc of $$("[data-tampons]")) {
      const carte = $("[data-tampons-carte]", bloc);
      // Le serveur fixe le nombre de cases ; la page part de quatre
      if ($$(".tampon", carte).length !== t.par_carte) {
        carte.replaceChildren(
          ...Array.from({ length: t.par_carte }, (_, i) => {
            const li = document.createElement("li");
            li.className = "tampon";
            const signe = document.createElement("span");
            signe.className = "signe";
            signe.setAttribute("aria-hidden", "true");
            // L'empreinte pleine vient de la carte rendue par le thème (snippets/patte.liquid)
            signe.innerHTML = i === t.par_carte - 1 ? icone("gift", 22) : $(".tampon .patte")?.outerHTML || icone("paw-print", 22);
            li.append(signe);
            return li;
          }),
        );
      }
      $$(".tampon", carte).forEach((li, i) => li.toggleAttribute("data-plein", i < remplis));
      carte.setAttribute("aria-label", remplir(T.stampsLabel, { n: remplis, total: t.par_carte }));
      $("[data-tampons-texte]", bloc).textContent =
        reste > 0 ? remplir(T.stampsLeft[pluriel.select(reste)] || T.stampsLeft.other, { n: reste }) : offre ? remplir(T.stampsFullCode, { offre: offreTexte(offre) }) : T.stampsFull;
    }
  }

  function peindreCodes(e) {
    const bloc = $("[data-codes-bloc]");
    const modele = $("[data-code-modele]");
    if (!bloc || !modele) return;
    const tous = [
      ...e.anniversaires.map((a) => ({ ...a, origine: remplir(T.codeFromBirthday, { nom: a.animal }) })),
      ...e.codes.map((c) => ({ ...c, origine: remplir(T.codeFromStamps, { n: c.carte }) })),
    ];
    $("[data-codes-liste]", bloc).replaceChildren(
      ...tous.map((c) => {
        const li = modele.content.firstElementChild.cloneNode(true);
        $("[data-code-offre]", li).textContent = offreTexte(c);
        $("[data-code-origine]", li).textContent = c.origine;
        $("[data-code-valeur]", li).textContent = c.code;
        $("[data-copie]", li).dataset.copie = c.code;
        $("[data-code-fin]", li).textContent = c.fin ? remplir(T.codeUntil, { date: dateLisible(c.fin) }) : "";
        return li;
      }),
    );
    bloc.hidden = tous.length === 0;
  }

  function peindreParrainage(e) {
    if (!e.parrainage) return;
    // Le lien pose la réduction sur le panier de l'ami, puis le ramène à l'accueil
    const lien = lienParrainage(e.parrainage.code);
    for (const b of $$("[data-partage-ami]")) b.dataset.lien = lien;
  }

  function peindreAnnonce(e) {
    const bandeau = $("[data-annonce]");
    if (!bandeau) return;
    const vues = stockage.lire("annonces", []);
    const anniv = e.anniversaires.find((a) => !vues.includes(`anniv:${a.code}`));
    // Sur la fiche de l'objet à noter, le formulaire est déjà là
    const ici = $("[data-avis-ecrire]")?.dataset.produit;
    const avis = e.avis.find((a) => !vues.includes(`avis:${a.handle}`) && a.handle !== ici);
    const texte = $("[data-annonce-texte]", bandeau);
    const code = $("[data-annonce-code]", bandeau);
    const lien = $("[data-annonce-lien]", bandeau);
    let cle = "";
    if (anniv) {
      cle = `anniv:${anniv.code}`;
      bandeau.dataset.sorte = "fete";
      $("[data-annonce-signe]", bandeau).innerHTML = icone("cake", 20);
      texte.textContent = remplir(T.annivText, { nom: anniv.animal, offre: offreTexte(anniv), date: dateLisible(anniv.fin) });
      code.dataset.copie = anniv.code;
      $(".code", code).textContent = anniv.code;
      code.hidden = false;
    } else if (avis) {
      cle = `avis:${avis.handle}`;
      bandeau.dataset.sorte = "avis";
      $("[data-annonce-signe]", bandeau).innerHTML = icone("message-circle", 20);
      texte.textContent = remplir(T.avisAsk, { titre: avis.titre });
      lien.textContent = T.avisAskLink;
      lien.href = `${H.routes.racine}products/${encodeURIComponent(avis.handle)}#avis-donner`;
      lien.hidden = false;
    }
    if (!cle) return;
    // Fermée ou suivie, elle ne revient pas
    const retenir = () => stockage.ecrire("annonces", [...vues, cle].slice(-40));
    $("[data-annonce-fermer]", bandeau).addEventListener("click", () => {
      bandeau.hidden = true;
      retenir();
    });
    lien.addEventListener("click", retenir);
    bandeau.hidden = false;
  }

  if (H.client) {
    // Sur la page du carnet, les tampons sont relus : c'est là qu'on vient les compter
    lireEspace(Boolean($("[data-carnet]")))
      .then((e) => {
        if (!e?.connecte) return;
        peindreTampons(e);
        peindreCodes(e);
        peindreParrainage(e);
        peindreAnnonce(e);
      })
      .catch(() => {
        /* serveur endormi ou injoignable : la page garde ce qu'elle savait */
      });
  }

  /* --- Carte à gratter (carte-grattage.liquid) : après un moment avec des objets au panier --- */
  const carte = $("[data-grattage]");
  let minuteurGrattage = 0;
  let essaisGrattage = 0;
  let serveurEveille = false;
  // Le défi anti-robot et la création du code prennent une vingtaine de secondes : on les lance avant l'heure
  const AVANCE_CODE_MS = 25000;
  let minuteurPreparation = 0;
  let codePrepare = null;
  function suivreGrattage(panier) {
    if (!carte) return;
    clearTimeout(minuteurGrattage);
    clearTimeout(minuteurPreparation);
    const etat = stockage.lire("grattage", {});
    if (etat.fait) return;
    const nombre = typeof panier === "number" ? panier : panier?.item_count ?? 0;
    // Le compte part du premier objet posé, d'une page à l'autre ; panier vidé, il repart de zéro
    if (!nombre) {
      if (etat.debut) stockage.ecrire("grattage", {});
      return;
    }
    if (!etat.debut) {
      etat.debut = Date.now();
      stockage.ecrire("grattage", etat);
    }
    // Le serveur gratuit s'endort : réveillé maintenant, il a le temps de l'attente pour se lever
    if (!serveurEveille) {
      serveurEveille = true;
      fetch(`${agents}/conseil/etat`).catch(() => {});
    }
    const reste = etat.debut + Number(carte.dataset.delai || 30) * 1000 - Date.now();
    minuteurPreparation = setTimeout(preparerCode, Math.max(0, reste - AVANCE_CODE_MS));
    minuteurGrattage = setTimeout(montrerGrattage, Math.max(0, reste));
  }
  // Le plus haut palier atteint par le panier : la carte offre plus quand le panier est plus grand, jamais au hasard
  function choisirPalier(total) {
    let paliers = [];
    try {
      paliers = JSON.parse(carte.dataset.paliers || "[]");
    } catch {
      /* paliers illisibles : la carte de base */
    }
    if (!paliers.length) paliers = [{ min: 0, modele: carte.dataset.modele, offre: carte.dataset.offre }];
    const retenu = paliers.filter((p) => total >= p.min).sort((a, b) => b.min - a.min)[0] || paliers.sort((a, b) => a.min - b.min)[0];
    carte.dataset.modele = retenu.modele;
    carte.dataset.offre = retenu.offre;
    $(".grattage-offre", carte).textContent = retenu.offre;
  }
  // Le code vient du serveur : tiré pour cette carte, valable 15 minutes, il n'est écrit dans aucune page
  async function demanderCodeGrattage(modele) {
    const antibot = await preuve(agents, "code", null);
    const r = await fetch(`${agents}/codes/grattage`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ modele, antibot }),
    });
    if (!r.ok) throw new Error(String(r.status));
    return r.json();
  }
  // Le palier que le panier atteint maintenant ; rien si le panier s'est vidé
  async function palierDuPanier() {
    const panier = await fetch(`${H.routes.panier}.js`).then((r) => r.json()).catch(() => null);
    if (panier && panier.item_count === 0) return null;
    choisirPalier(panier?.total_price ?? 0);
    return carte.dataset.modele;
  }
  // Un code par modèle, demandé une seule fois : les rappels de suivreGrattage ne multiplient pas les codes
  function codePour(modele) {
    if (codePrepare?.modele !== modele) {
      const promesse = demanderCodeGrattage(modele);
      codePrepare = { modele, promesse };
      promesse.catch(() => {
        if (codePrepare?.promesse === promesse) codePrepare = null;
      });
    }
    return codePrepare.promesse;
  }
  async function preparerCode() {
    const modele = await palierDuPanier();
    if (modele) codePour(modele).catch(() => {});
  }
  async function montrerGrattage() {
    // Jamais par-dessus une feuille, la visionneuse ou le bandeau de consentement : on repasse plus tard
    const bandeauShopify = document.getElementById("shopify-pc__banner");
    const consentement = bandeauShopify?.offsetHeight > 0 && getComputedStyle(bandeauShopify).visibility !== "hidden";
    if (feuilleOuverte || consentement || $(".visionneuse") || $("[data-bandeau]:not([hidden])") || $("[data-preferences]:not([hidden])")) {
      minuteurGrattage = setTimeout(montrerGrattage, 5000);
      return;
    }
    const modele = await palierDuPanier();
    // Le panier s'est vidé pendant l'attente : la carte n'a plus de raison d'être
    if (!modele) return;
    try {
      let obtenu = await codePour(modele);
      // Un code préparé puis gardé longtemps derrière une feuille ouverte est remplacé avant d'être montré
      if (new Date(obtenu.fin) - Date.now() < 5 * 60000) {
        codePrepare = null;
        obtenu = await codePour(modele);
      }
      carte.dataset.code = obtenu.code;
      // L'échéance voyage avec le code : le panier en fera son compte à rebours
      stockage.ecrire("grattage-code", { code: obtenu.code, fin: obtenu.fin, offre: carte.dataset.offre });
      const heure = new Intl.DateTimeFormat(H.langue, { hour: "2-digit", minute: "2-digit" }).format(new Date(obtenu.fin));
      $("[data-grattage-code]", carte).textContent = remplir(T.codeGrattageAvant, { code: obtenu.code, heure });
    } catch {
      // Sans code, pas de carte : on retente dans une minute, deux fois au plus
      essaisGrattage += 1;
      if (essaisGrattage < 3) minuteurGrattage = setTimeout(montrerGrattage, 60000);
      return;
    }
    carte.showModal();
    requestAnimationFrame(() => {
      carte.dataset.visible = "";
      peindreCouche();
    });
  }
  function peindreCouche() {
    const toile = $("[data-grattage-couche]", carte);
    const { width: l, height: h } = toile.getBoundingClientRect();
    const dpr = window.devicePixelRatio || 1;
    toile.width = Math.round(l * dpr);
    toile.height = Math.round(h * dpr);
    const ctx = toile.getContext("2d");
    ctx.scale(dpr, dpr);
    // Une couche unie aux couleurs de la charte : lavande pâle sur le clair, lavande sur le sombre
    ctx.fillStyle = themeClair() ? "#e1dff3" : "#b4b2f0";
    ctx.fillRect(0, 0, l, h);
    // En filigrane, l'emblème de l'en-tête : un seul tracé pour toute la boutique
    const embleme = $(".brand-o");
    const traces = embleme ? [...embleme.querySelectorAll("path")].map(p => p.getAttribute("d")) : [];
    if (traces.length) {
      const cote = h * 0.9;
      const boite = embleme.viewBox.baseVal.width || 100;
      ctx.save();
      ctx.fillStyle = "rgba(10, 6, 5, 0.12)";
      ctx.translate(l - 8 - cote, (h - cote) / 2);
      ctx.scale(cote / boite, cote / boite);
      for (const trace of traces) ctx.fill(new Path2D(trace), "evenodd");
      ctx.restore();
    }
    ctx.textBaseline = "middle";
    ctx.fillStyle = "#0a0605";
    ctx.font = `700 20px Manrope, system-ui, sans-serif`;
    ctx.textAlign = "center";
    ctx.fillText(T.gratteIci, l / 2, h / 2);
  }
  function revelerGrattage() {
    if (carte.dataset.revele !== undefined) return;
    carte.dataset.revele = "";
    $("[data-grattage-dessous]", carte).removeAttribute("aria-hidden");
    $("[data-grattage-aide]", carte).hidden = true;
    $("[data-grattage-gain]", carte).hidden = false;
    stockage.ecrire("grattage", { fait: true });
    clearTimeout(minuteurGrattage);
    clearTimeout(minuteurPreparation);
    // La zone du gain s'annonce d'elle-même ; une notification cacherait le bouton sur téléphone
    $("[data-grattage-appliquer]", carte).focus();
    publier("carte_grattee", { offre: carte.dataset.offre });
  }
  function fermerGrattage() {
    if (carte.open) carte.close();
    delete carte.dataset.visible;
    // Fermée sans gratter, elle ne revient pas non plus : une relance suffit
    stockage.ecrire("grattage", { fait: true });
  }
  if (carte) {
    const toile = $("[data-grattage-couche]", carte);
    const piece = $("[data-grattage-piece]", carte);
    const calme = window.matchMedia?.("(prefers-reduced-motion: reduce)");
    const teintes = () => (themeClair() ? ["#f0d4c9", "#e9c3b5", "#dea08f", "#c98d7d"] : ["#f4643f", "#d8452b", "#a83019", "#ad3116"]);
    let trace = null;
    let traits = 0;
    // La pièce suit la souris ; au doigt, c'est le doigt qui gratte
    const suivre = (e) => {
      if (e.pointerType === "touch" || carte.dataset.revele !== undefined) return;
      const r = toile.getBoundingClientRect();
      piece.style.setProperty("--x", `${e.clientX - r.left}px`);
      piece.style.setProperty("--y", `${e.clientY - r.top}px`);
      carte.dataset.survol = "";
    };
    // Des éclats de vermillon sautent sous la pièce et retombent
    const eclats = (x, y) => {
      if (calme?.matches || !Element.prototype.animate) return;
      // Posés sur la carte entière, pas sur la couche : ils tombent hors du cadre
      const r = toile.getBoundingClientRect();
      const c = carte.getBoundingClientRect();
      const ox = x + r.left - c.left;
      const oy = y + r.top - c.top;
      const palette = teintes();
      for (let n = 0; n < 2; n++) {
        const eclat = document.createElement("span");
        eclat.className = "grattage-eclat";
        const taille = 3 + Math.random() * 4;
        eclat.style.cssText = `left:${ox}px;top:${oy}px;width:${taille}px;height:${taille * 0.7}px;background:${palette[(Math.random() * palette.length) | 0]}`;
        carte.append(eclat);
        const dx = (Math.random() - 0.5) * 60;
        const tour = (Math.random() - 0.5) * 540;
        eclat
          .animate(
            [
              { transform: "translate(-50%, -50%) rotate(0deg)", opacity: 1 },
              { transform: `translate(calc(-50% + ${dx * 0.6}px), calc(-50% - ${8 + Math.random() * 14}px)) rotate(${tour / 2}deg)`, opacity: 1, offset: 0.35 },
              { transform: `translate(calc(-50% + ${dx}px), calc(-50% + ${26 + Math.random() * 20}px)) rotate(${tour}deg)`, opacity: 0 },
            ],
            { duration: 560 + Math.random() * 240, easing: "cubic-bezier(0.22, 1, 0.36, 1)" },
          )
          .finished.then(() => eclat.remove(), () => eclat.remove());
      }
    };
    toile.addEventListener("pointerenter", suivre);
    toile.addEventListener("pointermove", suivre);
    toile.addEventListener("pointerleave", () => {
      delete carte.dataset.survol;
      delete piece.dataset.appui;
    });
    const usure = () => {
      // Part de vermillon enlevée, mesurée sur un point sur huit
      const { data } = toile.getContext("2d").getImageData(0, 0, toile.width, toile.height);
      let vides = 0;
      let total = 0;
      for (let i = 3; i < data.length; i += 32) {
        total += 1;
        if (data[i] === 0) vides += 1;
      }
      return total ? vides / total : 0;
    };
    const gratter = (e) => {
      const r = toile.getBoundingClientRect();
      const p = [e.clientX - r.left, e.clientY - r.top];
      const ctx = toile.getContext("2d");
      ctx.globalCompositeOperation = "destination-out";
      ctx.lineCap = "round";
      ctx.lineJoin = "round";
      ctx.lineWidth = 30;
      ctx.beginPath();
      ctx.moveTo(...(trace || p));
      ctx.lineTo(...p);
      ctx.stroke();
      if (!trace || traits % 2 === 0) eclats(...p);
      trace = p;
      traits += 1;
      if (traits % 12 === 0 && usure() > 0.5) revelerGrattage();
    };
    toile.addEventListener("pointerdown", (e) => {
      if (carte.dataset.revele !== undefined) return;
      toile.setPointerCapture?.(e.pointerId);
      piece.dataset.appui = "";
      trace = null;
      gratter(e);
    });
    toile.addEventListener("pointermove", (e) => {
      if (trace && carte.dataset.revele === undefined) gratter(e);
    });
    const lever = () => {
      delete piece.dataset.appui;
      if (!trace) return;
      trace = null;
      if (carte.dataset.revele === undefined && usure() > 0.5) revelerGrattage();
    };
    toile.addEventListener("pointerup", lever);
    toile.addEventListener("pointercancel", lever);
    $("[data-grattage-reveler]", carte).addEventListener("click", revelerGrattage);
    $("[data-grattage-fermer]", carte).addEventListener("click", fermerGrattage);
    // Échap ferme la fenêtre comme la croix
    carte.addEventListener("cancel", (e) => {
      e.preventDefault();
      fermerGrattage();
    });
    $("[data-grattage-appliquer]", carte).addEventListener("click", async () => {
      const code = carte.dataset.code;
      const bouton = $("[data-grattage-appliquer]", carte);
      bouton.disabled = true;
      try {
        const avant = await fetch(`${H.routes.panier}.js`)
          .then((r) => r.json())
          .then((p) => (p.discount_codes || []).filter((d) => d.applicable).map((d) => d.code))
          .catch(() => []);
        const reponse = await fetch(`${H.routes.racine}cart/update.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ discount: code, sections: "panier-tiroir" }),
        });
        const donnees = await reponse.json();
        const refuse = !reponse.ok || (donnees.discount_codes || []).some((d) => d.code.toLowerCase() === code.toLowerCase() && !d.applicable);
        if (refuse) {
          // Un code refusé ne reste pas accroché au panier : les codes d'avant reviennent
          await fetch(`${H.routes.racine}cart/update.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ discount: avant.join(",") }),
          }).catch(() => {});
          toast(remplir(T.codeRefuse, { code }));
          bouton.disabled = false;
          return;
        }
        fermerGrattage();
        publier("code_applique", { origine: "carte", offre: carte.dataset.offre });
        if ($("[data-panier-page]")) return location.reload();
        await rafraichirPanier(donnees.sections);
        toast(remplir(T.grattageApplique, { offre: carte.dataset.offre }));
      } catch {
        toast(T.erreurPanier);
        bouton.disabled = false;
      }
    });
    suivreGrattage(H.panierCompte);
  }

  /* --- Articles gardés pour plus tard (useSaved, Saved.jsx) --- */
  const gardes = stockage.lire("saved", []);
  const peindreGardes = () => {
    for (const c of $$("[data-compte-gardes]")) {
      c.textContent = gardes.length;
      c.hidden = gardes.length === 0;
    }
    for (const l of $$("[data-lien-gardes]")) l.hidden = gardes.length === 0;
  };
  document.addEventListener("click", async (e) => {
    const bouton = e.target.closest("[data-garder]");
    if (!bouton) return;
    const ligne = bouton.closest("[data-ligne]");
    if (!gardes.some((g) => g.id === bouton.dataset.garder)) {
      gardes.unshift({ id: bouton.dataset.garder, handle: bouton.dataset.handle });
      stockage.ecrire("saved", gardes);
    }
    await changerQuantite(ligne.dataset.ligne, 0);
    peindreGardes();
  });
  peindreGardes();

  const pageGardes = $("[data-gardes-page]");
  if (pageGardes) {
    const liste = $("[data-gardes-liste]", pageGardes);
    const modele = $("[data-gardes-modele]", pageGardes);
    const monnaie = (c) => new Intl.NumberFormat(H.langue, { style: "currency", currency: window.Shopify?.currency?.active || "EUR" }).format(c / 100);
    const dessiner = async () => {
      liste.innerHTML = "";
      const lus = await Promise.all(
        [...gardes].map((g) =>
          fetch(`${H.routes.racine}products/${g.handle}.js`)
            .then((r) => (r.ok ? r.json() : null))
            .catch(() => null),
        ),
      );
      for (const [n, g] of [...gardes].entries()) {
        const produit = lus[n];
        const variante = produit?.variants.find((v) => String(v.id) === g.id);
        if (!variante) continue;
        const li = modele.content.firstElementChild.cloneNode(true);
        for (const a of $$("[data-g-lien]", li)) a.href = `${produit.url}?variant=${variante.id}`;
        const image = variante.featured_image?.src || produit.featured_image;
        if (image) $(".line-art", li).innerHTML = `<img class="art art-photo" src="${image}${image.includes("?") ? "&" : "?"}width=176" alt="" width="88" height="88" loading="lazy">`;
        $("[data-g-nom]", li).textContent = produit.title + (variante.title !== "Default Title" ? `, ${variante.title}` : "");
        $("[data-g-prix]", li).textContent = monnaie(variante.price);
        // Un SKU sans tiret est celui d'un fournisseur : rien à montrer, comme sur la fiche
        const morceaux = (variante.sku || "").split("-");
        const code = morceaux.length >= 2 ? morceaux.slice(0, 2).join("-") : "";
        $("[data-g-code]", li).textContent = code;
        // Un article épuisé pendant l'attente reste visible, bouton inactif
        $("[data-g-stock]", li).innerHTML = variante.available ? "" : `<span class="stock stock-out">${T.epuise}</span>`;
        const versPanier = $("[data-g-panier]", li);
        versPanier.disabled = !variante.available;
        versPanier.addEventListener("click", async () => {
          try {
            await ajouterAuPanier(variante.id, 1);
            retirer(g.id);
            ouvrirFeuille("panier");
          } catch (err) {
            toast(err.message);
          }
        });
        $("[data-g-retirer]", li).addEventListener("click", () => retirer(g.id));
        liste.append(li);
      }
      liste.hidden = liste.children.length === 0;
      $("[data-gardes-vide]", pageGardes).hidden = liste.children.length > 0;
      const compte = $("[data-gardes-compte]", pageGardes);
      if (compte) compte.textContent = liste.children.length ? remplir(T.objets[new Intl.PluralRules(H.langue).select(liste.children.length)] || T.objets.other, { n: liste.children.length }) : "";
    };
    const retirer = (id) => {
      const i = gardes.findIndex((g) => g.id === id);
      if (i >= 0) gardes.splice(i, 1);
      stockage.ecrire("saved", gardes);
      peindreGardes();
      dessiner();
    };
    dessiner();
  }

  /* --- Défi anti-robots (antibot.js) : la preuve de travail, dans un fil à part --- */
  const zerosEnTete = (octets) => {
    let bits = 0;
    for (const o of octets) {
      if (o === 0) {
        bits += 8;
        continue;
      }
      bits += 8 - o.toString(2).length;
      break;
    }
    return bits;
  };
  function miner(sel, difficulte) {
    const code = `self.onmessage=async(e)=>{const{sel,difficulte}=e.data;const enc=new TextEncoder();const z=${zerosEnTete.toString()};let n=0;for(;;){const h=new Uint8Array(await crypto.subtle.digest("SHA-256",enc.encode(sel+n)));if(z(h)>=difficulte){self.postMessage(String(n));return}n++}}`;
    try {
      const fil = new Worker(URL.createObjectURL(new Blob([code], { type: "text/javascript" })));
      return new Promise((resoudre, rejeter) => {
        fil.onmessage = (e) => {
          fil.terminate();
          resoudre(e.data);
        };
        fil.onerror = (e) => {
          fil.terminate();
          rejeter(e);
        };
        fil.postMessage({ sel, difficulte });
      });
    } catch {
      return (async () => {
        const enc = new TextEncoder();
        for (let n = 0; ; n++) {
          const h = new Uint8Array(await crypto.subtle.digest("SHA-256", enc.encode(sel + n)));
          if (zerosEnTete(h) >= difficulte) return String(n);
          if (n % 500 === 0) await new Promise((r) => setTimeout(r, 0));
        }
      })();
    }
  }
  async function preuve(api, usage, piege) {
    const defi = await fetch(`${api}/security/challenge?purpose=${encodeURIComponent(usage)}`).then((r) => {
      if (!r.ok) throw Object.assign(new Error("defi"), { status: r.status });
      return r.json();
    });
    const nonce = await miner(defi.salt, defi.difficulty);
    const attente = defi.min_seconds * 1000 - (Date.now() - defi.issued_at * 1000);
    if (attente > 0) await new Promise((r) => setTimeout(r, attente + 100));
    return { salt: defi.salt, issued_at: defi.issued_at, signature: defi.signature, nonce, honeypot: piege?.value ?? "" };
  }

  /* --- Offre de bienvenue : le code pour qui est inscrit à la lettre, l'inscription pour les autres --- */
  const offre = $("[data-offre]");
  // L'inscription ramène sur la page avec customer_posted : ce navigateur est alors tenu pour inscrit
  if (new URLSearchParams(location.search).get("customer_posted") === "true") {
    stockage.ecrire("lettre", true);
    mesurer("offre", { o: 2 });
  }
  // L'ouverture lui réserve sa place dès la première peinture (theme.liquid) : on la lui rend si elle ne vient pas
  if (!offre || stockage.lire("offre", "")) document.documentElement.classList.remove("offre-posee");
  else {
    const code = offre.dataset.code;
    const inscrit = offre.dataset.offre === "code" || (offre.dataset.offre === "visiteur" && stockage.lire("lettre", false));
    const phrase = $("[data-offre-code]", offre);
    const refus = $("[data-offre-refus]", offre);
    phrase.hidden = !inscrit;
    $("[data-offre-invite]", offre).hidden = inscrit;
    const racine = document.documentElement;
    const ranger = (suite) => {
      stockage.ecrire("offre", suite);
      offre.hidden = true;
      racine.classList.remove("offre-posee");
      racine.style.removeProperty("--hauteur-offre");
    };
    // Le bandeau de consentement passe d'abord : l'offre attend la réponse
    const guet = new MutationObserver(() => montrerOffre());
    function montrerOffre() {
      if (racine.classList.contains("bandeau-attendu") || $("[data-bandeau]:not([hidden])")) return;
      guet.disconnect();
      offre.hidden = false;
      // Une fois par session : la fenêtre revient à chaque page tant qu'elle n'est pas rangée
      if (!memoire.lire("offre-vue")) {
        memoire.ecrire("offre-vue", true);
        mesurer("offre", { o: 1 });
      }
      // L'ouverture de l'accueil garde sa phrase et son bouton au-dessus, comme pour le bandeau
      racine.classList.add("offre-posee");
      // Sa hauteur remonte les notifications, qui s'afficheraient dessous
      if ("ResizeObserver" in window) {
        new ResizeObserver(([e]) => {
          if (!offre.hidden) racine.style.setProperty("--hauteur-offre", `${Math.ceil(e.borderBoxSize?.[0]?.blockSize ?? offre.offsetHeight) + 8}px`);
        }).observe(offre);
      }
    }
    guet.observe(racine, { attributes: true, attributeFilter: ["class"] });
    if ($("[data-bandeau]")) guet.observe($("[data-bandeau]"), { attributes: true, attributeFilter: ["hidden"] });
    montrerOffre();

    // Sur ordinateur, l'offre est à gauche comme le bouton de l'ouverture : elle attend que l'ouverture soit presque passée (le CSS ne s'en sert qu'au-delà de 48rem)
    const ouverture = $(".scene, .vt-ouverture");
    if (ouverture && "IntersectionObserver" in window) {
      new IntersectionObserver(([e]) => racine.classList.toggle("ouverture-visible", e.isIntersecting), { threshold: 0.25 }).observe(ouverture);
    }

    refus.addEventListener("click", () => ranger(refus.dataset.suite || "refus"));
    $("[data-offre-appliquer]", offre).addEventListener("click", async (e) => {
      const bouton = e.currentTarget;
      bouton.disabled = true;
      try {
        const avant = await fetch(`${H.routes.panier}.js`)
          .then((r) => r.json())
          .then((p) => (p.discount_codes || []).filter((d) => d.applicable && d.code.toLowerCase() !== code.toLowerCase()).map((d) => d.code))
          .catch(() => []);
        const reponse = await fetch(`${H.routes.racine}cart/update.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ discount: [...avant, code].join(","), sections: "panier-tiroir" }),
        });
        if (!reponse.ok) throw new Error("offre");
        const donnees = await reponse.json();
        navigator.clipboard?.writeText(code).catch(() => {});
        publier("code_applique", { origine: "bienvenue" });
        mesurer("offre", { o: 3 });
        stockage.ecrire("offre", "pris");
        if ($("[data-panier-page]")) return location.reload();
        await rafraichirPanier(donnees.sections);
        // La fenêtre dit ce qui vient de se passer, puis se ferme d'un clic
        phrase.textContent = remplir(T.offreRetenue, { code });
        phrase.setAttribute("role", "status");
        refus.textContent = T.fermer;
        refus.dataset.suite = "pris";
      } catch {
        toast(T.erreurPanier);
        bouton.disabled = false;
      }
    });
  }

  /* --- Consentement (BandeauCookies.jsx) sur l'API de confidentialité de Shopify --- */
  const bandeau = $("[data-bandeau]");
  const preferences = $("[data-preferences]");
  // L'ouverture réserve la place du bandeau dès la première peinture (theme.liquid) : on la lui rend s'il ne vient pas
  const placeRendue = (repondu) => {
    document.documentElement.classList.remove("bandeau-attendu");
    if (!repondu) return;
    try {
      localStorage.setItem("animolife:cookies", "1");
    } catch {
      /* navigation privée : la place sera réservée à la prochaine page */
    }
  };
  if (!bandeau || !window.Shopify?.loadFeatures) placeRendue(false);
  if (bandeau && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], (erreur) => {
      const api = window.Shopify.customerPrivacy;
      if (erreur || !api) return placeRendue(false);
      // shouldShowBanner dit seulement que la région exige un consentement : un visiteur qui a déjà répondu ne revoit pas le bandeau
      const dejaChoisi = () => {
        const suivi = api.getTrackingConsent?.();
        if (suivi) return suivi !== "no_interaction";
        return Object.values(api.currentVisitorConsent?.() || {}).some((v) => v === "yes" || v === "no");
      };
      if (api.shouldShowBanner?.() && !dejaChoisi()) {
        bandeau.hidden = false;
        // Sa hauteur remonte les notifications, qui s'afficheraient dessous
        if ("ResizeObserver" in window) {
          new ResizeObserver(([e]) => document.documentElement.style.setProperty("--hauteur-bandeau", `${Math.ceil(e.borderBoxSize?.[0]?.blockSize ?? bandeau.offsetHeight) + 8}px`)).observe(bandeau);
        }
      } else {
        placeRendue(dejaChoisi());
      }
      const poser = (valeurs) =>
        api.setTrackingConsent({ ...valeurs, headlessStorefront: false }, () => {
          placeRendue(true);
          bandeau.hidden = true;
          preferences.hidden = true;
          document.documentElement.style.removeProperty("--hauteur-bandeau");
          verrouiller(false);
        });
      const tout = (oui) => ({ analytics: oui, marketing: oui, preferences: oui, sale_of_data: oui });
      document.addEventListener("click", (e) => {
        const action = e.target.closest("[data-consent]")?.dataset.consent;
        if (!action) return;
        if (action === "accepter") poser(tout(true));
        else if (action === "refuser") poser(tout(false));
        else if (action === "fermer") {
          preferences.hidden = true;
          verrouiller(false);
        } else if (action === "personnaliser") {
          const actuels = { analytics: api.analyticsProcessingAllowed?.(), marketing: api.marketingAllowed?.(), preferences: api.preferencesProcessingAllowed?.() };
          for (const c of $$("[data-finalite]", preferences)) c.checked = Boolean(actuels[c.dataset.finalite]);
          preferences.hidden = false;
          verrouiller(true);
          $("[data-finalite]", preferences)?.focus();
        } else if (action === "enregistrer") {
          const v = {};
          for (const c of $$("[data-finalite]", preferences)) v[c.dataset.finalite] = c.checked;
          poser({ ...v, sale_of_data: Boolean(v.marketing) });
        }
      });
    });
  }

  // Les modules chargés après ce fichier (accueil, fiche, pages) reprennent ces noms
  window.animolife = Object.assign(window.animolife || {}, { o: { H, T, agents, decodeur, decoder, $, $$, icone, remplir, publier, stockage, memoire, mesure, mesureEnvoyer, mesurer, mesureSurPanier, pluriel, dateLisible, offreTexte, nomPermis, themeClair, lienInterdit, signaler, minuteurToast, toast, menusPays, avisPays, COULEUR_BARRE, systeme, themeCourant, appliquerTheme, FOCUSABLE, feuilleOuverte, focusAvant, verrouiller, armerImages, ouvrirFeuille, fermerFeuille, rafraichirPanier, ajouterAuPanier, changerQuantite, combos, combosVus, lireCombo, chargerCombo, proposerCombo, achatVitrine, barreVitrine, nombre, rebond, modeleBesoin, navGlisse, panneau, ouvrePanneau, champConseil, joursOuvresPlus, remplirDatesLivraison, favoris, peindreFavoris, rendreFavoris, marquerVue, armerCase, rubanAttendu, poserCode, deuxChiffres, minuteurOffre, peindreMinuteurs, lancerMinuteurs, retirerCodeExpire, photoEnDonnees, serie, lienParrainage, populaireEnCours, lirePopulaire, envoyerRadar, rechercheVide, lireEspace, peindreTampons, peindreCodes, peindreParrainage, peindreAnnonce, carte, minuteurGrattage, essaisGrattage, serveurEveille, AVANCE_CODE_MS, minuteurPreparation, codePrepare, suivreGrattage, choisirPalier, demanderCodeGrattage, palierDuPanier, codePour, preparerCode, montrerGrattage, peindreCouche, revelerGrattage, fermerGrattage, gardes, peindreGardes, pageGardes, zerosEnTete, miner, preuve, offre, bandeau, preferences, placeRendue } });
})();
